import { useQuery } from "@tanstack/vue-query";
import { authService } from "~/utils/api/authService";
import { computed } from "vue";

export function useUser() {
  const { formatDateDDMMYYYY } = useFormatDate();
  const { data, isFetched: isUser } = useQuery({
    queryKey: ["user"],
    queryFn: authService.getAccount,
  });

  const projectId = computed(() => data.value?.latest_client_project?.id);
  const latestUpdate = computed(() =>
    formatDateDDMMYYYY(
      data.value?.latest_client_project?.latest_notification?.created_at ?? "",
    ),
  );
  const userName = computed(
    () => data.value?.first_name + " " + data.value?.last_name,
  );
  const progress = computed(() =>
    Math.round(data.value?.latest_client_project?.progress ?? 0),
  );

  return {
    userName,
    projectId,
    isUser,
    data,
    latestUpdate,
    progress,
  };
}
